<template>
  <button
    v-on:click="buttonClick"
    :disabled="disabled || (attributeIdsWithStock.length === 0 && hasAttributes)"
    class="add-to-cart-btn">
    <span class="d-none">{{ t('button') }}</span>
    <slot>{{ t('button') }}</slot>
  </button>
</template>

<script>
import store from '../../../vue/store'

export default {
  name: 'AdvButton',
  props: {
    productId: Number,
    quantity: Number,
    disabled: {
      type: Boolean,
      default: false
    },
    comboProgress: {
      type: Boolean,
      default: false
    },
    isListing: {
      type: Boolean,
      default: false
    },
    isVariationGroupMaster: {
      type: Boolean,
      default: false
    },
    attributeIdsWithStock: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    productData () {
      return store.getters.getProductById(this.productId)
    },
    hasAttributes () {
      return this.productData.productCodes.length > 1
    }
  },
  methods: {
    buttonClick () {
      this.$emit('btn-click')
      const productPrice = this.productData.productFinalPrice
      const barcode = this.productData.barCodes[0]
      const productQuantity = this.quantity

      const pixieEventOptions = {
        value: productPrice,
        currency: 'EUR',
        OrderID: barcode,
        Quantity: productQuantity
      }

      const taboolaEventOptions = {
        notify: 'event',
        name: 'add_to_cart',
        revenue: productPrice,
        orderid: barcode,
        currency: 'EUR',
        quantity: productQuantity
      }

      document.dispatchEvent(new CustomEvent('pixieAddToCart', {
        detail: {
          data: pixieEventOptions
        }
      }))

      document.dispatchEvent(new CustomEvent('taboolaAddToCart', {
        detail: {
          data: taboolaEventOptions
        }
      }))
    }
  }
}
</script>
